<template>
    <el-container class="home-container">
        <el-header>
            <div class="header-left">
                <span class="mobile-menu-btn" @click="togglCollapse()" v-if="isMobile">
                    <i class="el-icon-menu" style="font-size: 16px;"></i>
                </span>
                <div class="logo-area" @click="welcomePage()">
                    <h1 class="system-title">Art-Lens 小程序后管</h1>
                    <span v-if="showEnvironmentTag" :class="['env-tag', environmentTagClass]">{{ environmentLabel }}</span>
                </div>
            </div>
            <div class="header-right">
                <div class="user-info">
                    <div class="profile-btn" @click="goToProfile"><i class="el-icon-user"></i>个人中心</div>
                    <span class="username">{{ username }}</span>
                    <span class="role-tag">{{ role }}</span>
                </div>
                <el-button class="logout-btn" size="small" plain @click="logout()"><i class="el-icon-switch-button"></i>退出登录</el-button>
            </div>
        </el-header>
        
        <div class="mobile-overlay" v-if="isMobile && !isCollapse" @click="togglCollapse()"></div>

        <el-container>
            <el-aside :width="isCollapse ? '64px' : '200px'" :class="{ 'mobile-collapsed': isMobile && isCollapse }">
                <div class="toggle-button" @click="togglCollapse()">{{ isCollapse ? "展开" : "折叠" }}</div>
                <el-menu
                    background-color="#333744"
                    text-color="#fff"
                    active-text-color="#409eff"
                    unique-opened
                    :collapse="isCollapse"
                    :collapse-transition='false'
                    router
                    :default-active='activePath'
                >
                    <el-menu-item v-if="!isTeacherRole" index="/admin/welcome" @click="saveNavState('/admin/welcome')">
                        <i class="el-icon-s-home"></i>
                        <span slot="title">主页</span>
                    </el-menu-item>
                    <el-menu-item v-if="isTeacherRole" index="/admin/enrolls" @click="saveNavState('/admin/enrolls')">
                        <i class="el-icon-user-solid"></i>
                        <span slot="title">报名人列表</span>
                    </el-menu-item>
                    <el-submenu v-for="menu in menuList" :key="menu.id" :index="menu.id">
                        <template slot="title">
                            <i :class="menu.icon"></i>
                            <span>{{ menu.title }}</span>
                        </template>
                        <template v-for="subMenu in menu.children">
                            <!-- 如果有三级菜单 -->
                            <el-submenu v-if="subMenu.children && subMenu.children.length > 0" :key="subMenu.id || subMenu.path" :index="subMenu.id || subMenu.path">
                                <template slot="title">
                                    <i v-if="subMenu.icon" :class="subMenu.icon"></i>
                                    <span>{{ subMenu.title }}</span>
                                </template>
                                <el-menu-item 
                                    v-for="thirdMenu in subMenu.children" 
                                    :key="thirdMenu.path" 
                                    :index="thirdMenu.path" 
                                    @click="saveNavState(thirdMenu.path)"
                                >
                                    <i v-if="thirdMenu.icon" :class="thirdMenu.icon"></i>
                                    <span slot="title">{{ thirdMenu.title }}</span>
                                </el-menu-item>
                            </el-submenu>
                            <!-- 如果是二级菜单项 -->
                            <el-menu-item v-else :key="subMenu.path" :index="subMenu.path" @click="saveNavState(subMenu.path)">
                                <i v-if="subMenu.icon" :class="subMenu.icon"></i>
                            <span slot="title">{{ subMenu.title }}</span>
                        </el-menu-item>
                        </template>
                    </el-submenu>
                </el-menu>
            </el-aside>

            <el-main :class="{ 'no-padding': isWelcomePage }">
                <router-view></router-view>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
import { removeToken } from '@/utils/auth'
import { RUNTIME_ENV } from '@/utils/urls'
export default {
    name: 'Home',
    data(){
        return {
            isCollapse: false,
            isMobile: false,
            activePath: '',
            username: '',
            role: '',
            roleList: [
                { id: 1, name: '超级管理员' },
                { id: 2, name: '管理员' },
                { id: 3, name: '运营' },
                { id: 4, name: '客服' },
                { id: 5, name: '财务' },
                { id: 6, name: '带队老师' }
            ],
            menus: [
                {
                    id: '001',
                    title: '人员管理',
                    icon: 'el-icon-user-solid',
                    roles: [1, 2],
                    children: [
                        {
                            id: '001-1',
                            title: '员工与用户',
                            icon: 'el-icon-s-platform',
                            roles: [1, 2],
                            children: [
                                {
                                    path: '/admin/staffs',
                                    title: '员工列表',
                                    icon: 'el-icon-monitor',
                                    roles: [1, 2]
                                },
                                {
                                    path: '/admin/users',
                                    title: '用户列表',
                                    icon: 'el-icon-mobile',
                                    roles: [1, 2]
                                }
                            ]
                        },
                        {
                            id: '001-2',
                            title: '权限与角色',
                            icon: 'el-icon-s-custom',
                            roles: [1, 2],
                            children: [
                                {
                                    path: '/admin/permissions',
                                    title: '权限管理',
                                    icon: 'el-icon-lock',
                                    roles: [1]
                                },
                                {
                                    path: '/admin/roles',
                                    title: '角色管理',
                                    icon: 'el-icon-user',
                                    roles: [1, 2]
                                }
                            ]
                        }
                    ]
                },
                {
                    id: '002',
                    title: '活动管理',
                    icon: 'el-icon-s-promotion',
                    roles: [1, 2, 3],
                    children: [
                        {
                            path: '/admin/activities',
                            title: '活动列表',
                            icon: 'el-icon-star-off',
                            roles: [1, 2, 3]
                        },
                        {
                            path: '/admin/activity/create',
                            title: '活动创建',
                            icon: 'el-icon-plus',
                            roles: [1, 2, 3]
                        },
                        {
                            id: '002-2',
                            title: '活动属性',
                            icon: 'el-icon-s-data',
                            roles: [1, 2, 3],
                            children: [
                                {
                                    path: '/admin/cities',
                                    title: '活动城市',
                                    icon: 'el-icon-location-information',
                                    roles: [1, 2, 3]
                                },
                                {
                                    path: '/admin/features',
                                    title: '活动特色',
                                    icon: 'el-icon-star-off',
                                    roles: [1, 2, 3]
                                },
                                {
                                    path: '/admin/tags',
                                    title: '活动标签',
                                    icon: 'el-icon-collection-tag',
                                    roles: [1, 2, 3]
                                },
                                {
                                    path: '/admin/audiences',
                                    title: '报名人群',
                                    icon: 'el-icon-user',
                                    roles: [1, 2, 3]
                                }
                            ]
                        }
                    ]
                },
                {
                    id: '003',
                    title: '商城管理',
                    icon: 'el-icon-s-shop',
                    roles: [1, 2, 3, 4, 5],
                    children: [
                        {
                            id: '003-1',
                            title: '商品与分类',
                            icon: 'el-icon-s-goods',
                            roles: [1, 2, 3],
                            children: [
                                {
                                    path: '/admin/shop',
                                    title: '商品列表',
                                    icon: 'el-icon-shopping-cart-full',
                                    roles: [1, 2, 3]
                                },
                                {
                                    path: '/admin/shop/cates',
                                    title: '商品分类',
                                    icon: 'el-icon-collection-tag',
                                    roles: [1, 2, 3]
                                }
                            ]
                        },
                        {
                            id: '003-2',
                            title: '订单与导出',
                            icon: 'el-icon-s-order',
                            roles: [1, 2, 4, 5],
                            children: [
                                {
                                    path: '/admin/shop/orders',
                                    title: '商城订单',
                                    icon: 'el-icon-document',
                                    roles: [1, 2, 4, 5]
                                },
                                {
                                    path: '/admin/shop/export',
                                    title: '导出订单',
                                    icon: 'el-icon-download',
                                    roles: [1, 2, 4, 5]
                                }
                            ]
                        }
                    ]
                },
                {
                    id: '004',
                    title: '内容管理',
                    icon: 'el-icon-s-opportunity',
                    roles: [1, 2, 3],
                    children: [
                        {
                            id: '004-1',
                            title: '首页轮播',
                            icon: 'el-icon-picture',
                            roles: [1, 2, 3],
                            children: [
                                {
                                    path: '/admin/banners',
                                    title: '轮播列表',
                                    icon: 'el-icon-picture-outline',
                                    roles: [1, 2, 3]
                                },
                                {
                                    path: '/admin/banner/create',
                                    title: '轮播创建',
                                    icon: 'el-icon-plus',
                                    roles: [1, 2, 3]
                                }
                            ]
                        },
                        {
                            id: '004-2',
                            title: '活动瞬间',
                            icon: 'el-icon-camera-solid',
                            roles: [1, 2, 3],
                            children: [
                                {
                                    path: '/admin/events',
                                    title: '活动瞬间列表',
                                    icon: 'el-icon-camera',
                                    roles: [1, 2, 3]
                                },
                                {
                                    path: '/admin/event/create',
                                    title: '活动瞬间创建',
                                    icon: 'el-icon-plus',
                                    roles: [1, 2, 3]
                                }
                            ]
                        }
                    ]
                },
                {
                    id: '007',
                    title: '订单与报名',
                    icon: 'el-icon-s-order',
                    roles: [1, 2, 4, 5],
                    children: [
                        {
                            path: '/admin/orders',
                            title: '订单列表',
                            icon: 'el-icon-document',
                            roles: [1, 2, 4, 5]
                        },
                        {
                            path: '/admin/enrolls',
                            title: '报名人列表',
                            icon: 'el-icon-user',
                            roles: [1, 2, 4, 5]
                        },
                        {
                            path: '/admin/enroll/create',
                            title: '报名人录入',
                            icon: 'el-icon-plus',
                            roles: [1, 2]
                        },
                        {
                            path: '/admin/export',
                            title: '统计与导出',
                            icon: 'el-icon-download',
                            roles: [1, 2, 4, 5]
                        }
                    ]
                },
                {
                    id: '008',
                    title: '推荐码管理',
                    icon: 'el-icon-s-ticket',
                    roles: [1, 2, 3, 4],
                    children: [
                        {
                            path: '/admin/inviters',
                            title: '推荐码列表',
                            icon: 'el-icon-receiving',
                            roles: [1, 2, 3, 4]
                        }
                    ]
                },
                {
                    id: '009',
                    title: '系统管理',
                    icon: 'el-icon-s-operation',
                    roles: [1, 2],
                    children: [
                        {
                            path: '/admin/logs',
                            title: '日志管理',
                            icon: 'el-icon-document',
                            roles: [1, 2]
                        }
                    ]
                }
            ]
        }
    },
    computed: {
        isTeacherRole() {
            return this.role === '带队老师';
        },
        isWelcomePage() {
            return this.$route.path === '/admin/welcome';
        },
        menuList() {
            const userRoleId = this.roleList.find(role => role.name === this.role)?.id;
            if (!userRoleId) return [];
            
            return this.menus
                .filter(menu => menu.roles.includes(userRoleId))
                .map(menu => {
                    const filteredChildren = menu.children
                        .filter(child => child.roles.includes(userRoleId))
                        .map(child => {
                            // 如果有三级菜单，也需要过滤
                            if (child.children && child.children.length > 0) {
                                return {
                                    ...child,
                                    children: child.children.filter(thirdChild => thirdChild.roles.includes(userRoleId))
                                };
                            }
                            return child;
                        })
                        .filter(child => {
                            // 如果三级菜单被过滤后为空，则移除该二级菜单
                            if (child.children && child.children.length === 0) {
                                return false;
                            }
                            return true;
                        });
                    
                    return {
                    ...menu,
                        children: filteredChildren
                    };
                });
        },
        environmentLabel() {
            if (RUNTIME_ENV === 'production') {
                return '';
            }
            if (RUNTIME_ENV === 'development') {
                return '测试环境';
            }
            return '开发环境';
        },
        showEnvironmentTag() {
            return Boolean(this.environmentLabel);
        },
        environmentTagClass() {
            if (RUNTIME_ENV === 'development') {
                return 'env-tag--test';
            }
            if (RUNTIME_ENV === 'production') {
                return '';
            }
            return 'env-tag--dev';
        }
    },
    created(){
        this.getUserInfo()
        this.activePath = window.sessionStorage.getItem('activePath') || '/admin/welcome'
        this.checkIsMobile()
    },
    mounted() {
        window.addEventListener('resize', this.handleResize)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize)
    },
    methods: {
        getUserInfo(){
            this.$http({ method: 'get', url: 'users/me' }).then(res => {
                this.username = res.data.username
                this.role = this.roleList.find(role => role.id === res.data.role).name
                
                // 如果是带队老师，设置默认状态
                if (this.role === '带队老师') {
                    this.isCollapse = true
                    // 如果没有保存的路径或路径是welcome，则跳转到报名人列表
                    if (!window.sessionStorage.getItem('activePath') || window.sessionStorage.getItem('activePath') === '/admin/welcome') {
                        this.$router.push('/admin/enrolls')
                        this.saveNavState('/admin/enrolls')
                    } else {
                        this.activePath = window.sessionStorage.getItem('activePath')
                    }
                }
            }).catch(err => {
                this.$message.error(err.response?.data?.message || '获取用户信息失败')
            })
        },
        welcomePage(){
            if (this.$route.path !== '/admin/welcome'){
                this.$router.push('/admin/welcome')
            }
        },
        checkIsMobile() {
            this.isMobile = window.innerWidth < 768
            if (this.isMobile) {
                this.isCollapse = true
            }
        },
        handleResize() {
            const wasMobile = this.isMobile
            this.checkIsMobile()
            if (!wasMobile && this.isMobile) {
                this.isCollapse = true
            }
        },
        togglCollapse(){
            this.isCollapse = !this.isCollapse
        },
        saveNavState(activePath){
            window.sessionStorage.setItem('activePath', activePath)
            this.activePath = activePath
        },
        goToProfile() {
            if (this.$route.path !== '/admin/aboutme'){
                this.$router.push('/admin/aboutme')
            }
        },
        logout(){
            removeToken()
            this.$router.push('/admin/login')
            this.$message.warning('已退出登录')
            window.sessionStorage.removeItem('activePath')
        }
    }
}
</script>

<style scoped>
.home-container {
    height: 100%;
}

.el-header {
    background-color: #373d41;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    color: #fff;
    box-shadow: 0 2px 4px rgba(0,0,0,.12);
}

.header-left {
    display: flex;
    align-items: center;
    cursor: pointer;
}

.logo-area {
    display: flex;
    align-items: center;
    cursor: pointer;
}

.system-title {
    font-size: 20px;
    font-weight: 500;
    margin: 0;
}

.env-tag {
    margin-left: 12px;
    padding: 4px 12px;
    border-radius: 999px;
    font-size: 12px;
    line-height: 1;
    border: 1px solid transparent;
    display: inline-flex;
    align-items: center;
    letter-spacing: 1px;
    transition: all 0.2s ease;
}

.env-tag--dev {
    background: rgba(64, 158, 255, 0.16);
    border-color: rgba(64, 158, 255, 0.35);
    color: #c6e2ff;
}

.env-tag--test {
    background: rgba(245, 108, 108, 0.16);
    border-color: rgba(245, 108, 108, 0.35);
    color: #ffd9d9;
}

.header-right {
    display: flex;
    align-items: center;
    gap: 20px;
}

.user-info {
    position: relative;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px;
    padding-left: 40px;
    cursor: pointer;
}

.username {
    font-size: 14px;
}

.role-tag {
    background: rgba(255,255,255,0.1);
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 12px;
}

.el-button.is-plain {
    background: transparent;
    border-color: rgba(255,255,255,0.2);
    color: #fff;
    border-radius: 16px;
}

.el-button.is-plain:hover {
    background: rgba(255,255,255,0.1);
    border-color: rgba(255,255,255,0.3);
    color: #fff;
}

.el-aside {
    background-color: #333744;
    transition: 0.1s linear;
    overflow: hidden;
}

.el-aside .el-menu {
    border-right: none;
    height: calc(100vh - 60px);
    overflow-y: auto;
    overflow-x: hidden;
}

/* 菜单滚动条样式 */
.el-aside .el-menu::-webkit-scrollbar {
    width: 6px;
}

.el-aside .el-menu::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 3px;
}

.el-aside .el-menu::-webkit-scrollbar-thumb:hover {
    background-color: rgba(255, 255, 255, 0.3);
}

/* 三级菜单样式优化 */
.el-menu .el-submenu .el-submenu__title {
    padding-left: 20px !important;
}

.el-menu .el-submenu .el-menu-item {
    padding-left: 40px !important;
}

.el-menu .el-submenu .el-submenu .el-menu-item {
    padding-left: 60px !important;
}

/* 菜单项悬停效果 */
.el-menu-item:hover,
.el-submenu__title:hover {
    background-color: rgba(255, 255, 255, 0.05) !important;
}

.el-main {
    background-color: #eaedf1;
    height: calc(100vh - 30px);
    overflow-y: auto;
    padding: 20px;
}

.el-main.no-padding {
    padding: 0;
    background-color: transparent;
}

.toggle-button {
    background-color: #4a5064;
    font-size: 10px;
    line-height: 24px;
    color: #fff;
    text-align: center;
    letter-spacing: 2px;
    cursor: pointer;
}

.profile-btn {
    position: absolute;
    left: -100px;
    transform: translateX(35px) !important;
    background: rgba(255, 255, 255, 0.1);
    color: white;
    padding: 6px 12px;
    border-radius: 16px;
    opacity: 0;
    transition: all 0.3s ease;
    white-space: nowrap;
    font-size: 13px;
    font-weight: 400;
    display: flex;
    align-items: center;
    gap: 4px;
    backdrop-filter: blur(8px);
    border: 1px solid rgba(255, 255, 255, 0.1);
}

.user-info:hover .profile-btn {
    left: -110px;
    opacity: 1;
    transform: translateX(0);
}

.profile-btn:hover {
    background: rgba(255, 255, 255, 0.15);
    transform: translateY(-1px);
}

.profile-btn i {
    font-size: 14px;
}

.logout-btn i {
    margin-right: 4px;
}

.mobile-menu-btn {
    display: none;
    font-size: 24px;
    cursor: pointer;
    padding: 8px;
    color: #fff;
}

@media (max-width: 768px) {
    .home-container {
        height: 100%;
    }

    .el-header {
        padding: 0 15px;
        height: auto;
        min-height: 50px;
    }

    .header-left {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .mobile-menu-btn {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .logo-area {
        display: flex;
        align-items: center;
    }

    .system-title {
        display: none;
    }

    .env-tag {
        margin-left: 0;
        padding: 3px 8px;
        font-size: 10px;
    }

    .header-right {
        gap: 10px;
    }

    .user-info {
        padding-left: 0;
        gap: 6px;
    }

    .username {
        display: none;
    }

    .role-tag {
        font-size: 11px;
        padding: 2px 6px;
    }

    .logout-btn {
        padding: 4px 8px;
        font-size: 12px;
    }

    .logout-btn i {
        margin-right: 2px;
    }

    .profile-btn {
        display: none;
    }

    .el-aside {
        position: fixed;
        top: 50px;
        left: 0;
        z-index: 1000;
        height: calc(100vh - 50px);
        box-shadow: 2px 0 10px rgba(0,0,0,0.3);
        transition: transform 0.3s ease;
    }

    .el-aside.mobile-collapsed {
        transform: translateX(-100%);
    }

    .el-aside:not(.mobile-collapsed) {
        transform: translateX(0);
    }

    .toggle-button {
        display: none;
    }

    .el-main {
        padding: 10px;
        height: calc(100vh - 50px);
    }

    .mobile-overlay {
        position: fixed;
        top: 50px;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0,0,0,0.5);
        z-index: 999;
    }
}

</style>